var _style, _metadata, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000056428552012137326350000010977998562926352800_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7F3C1;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0,
    y: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,29.3h8.2c0.8,0,1.4,0.2,1.9,0.5s0.6,0.8,0.6,1.4c0,0.5-0.2,0.9-0.5,1.3S28.7,33,28,33H16.5 c-0.8,0-1.4-0.2-1.8-0.7c-0.4-0.4-0.7-0.9-0.7-1.5c0-0.4,0.1-0.9,0.4-1.5s0.6-1.1,0.9-1.5c1.4-1.4,2.6-2.7,3.8-3.7s1.9-1.7,2.4-2 c0.9-0.6,1.6-1.2,2.1-1.8s1-1.2,1.3-1.9s0.5-1.3,0.5-1.9c0-0.7-0.2-1.3-0.5-1.8s-0.8-0.9-1.3-1.2s-1.1-0.4-1.8-0.4 c-1.4,0-2.4,0.6-3.2,1.8c-0.1,0.2-0.3,0.6-0.5,1.3c-0.2,0.7-0.5,1.2-0.8,1.6s-0.8,0.6-1.4,0.6c-0.5,0-0.9-0.2-1.3-0.5S14,17,14,16.4 c0-0.7,0.2-1.5,0.5-2.3s0.8-1.5,1.4-2.1c0.7-0.6,1.5-1.1,2.4-1.5s2.1-0.6,3.5-0.6c1.6,0,3,0.2,4.1,0.8c0.7,0.3,1.4,0.8,1.9,1.4 s1,1.3,1.3,2s0.5,1.6,0.5,2.4c0,1.3-0.3,2.5-1,3.5s-1.3,1.9-2,2.5s-1.8,1.5-3.4,2.8c-1.6,1.3-2.6,2.3-3.2,3 C19.9,28.5,19.6,28.9,19.4,29.3L19.4,29.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt2);
export default __webpack_public_path__ + "static/media/CT2.6c5e66a07e256e73ffb406ba18becc12.svg";
export { ForwardRef as ReactComponent };